@if (data !== null) {
  <bp-modal-header class="font-semibold" [title]="getTitle() | translate: [asset?.getSymbol(false, true)]">
    <a right class="hover-pointer" (click)="close()" data-dismiss="modal" (keydown.enter)="close()" [tabIndex]="0">
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section mod-wide pt-25 pb-0">
      <div class="bp-modal-description">{{ "summary_sub_header" | translate }}</div>
      <div class="summary-grid">
        <summary-grid
          step="1"
          [titleKey]="getSummaryTitle(1)"
          class="summary-grid-item"
          [cssHover]="true"
          (onStepClick)="setEdit($event)">
          <ng-container iconContainer>
            <div class="summary-card__currency-symbol mb-10">
              <div class="summary-card__icons-container">
                <div class="summary-card__icons-container__item">
                  <img
                    [src]="fiat.getLogo()"
                    [style.width.px]="42"
                    (error)="img.src = fiat.getDefaultLogo()"
                    alt="{{ 'logo_alt_text' | translate }}"
                    #img />
                </div>
                <div class="summary-card__icons-container__item">
                  <img
                    [src]="asset.getLogo()"
                    [style.width.px]="42"
                    (error)="img.src = asset.getDefaultLogo()"
                    alt="{{ 'logo_alt_text' | translate }}"
                    #img />
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container detailsContainer>
            <span class="summary-card__text">
              {{
              "recurring_buy_modal_summary_container_one_description_buy"
              | translate: [asset?.getName()]
              }}
            </span>
            <br />
            <span class="summary-card__text">
              {{
              "recurring_buy_modal_summary_container_one_description_with"
              | translate: [fiat?.getSymbol()]
              }}
            </span>
          </ng-container>
        </summary-grid>
        <summary-grid
          step="2"
          [titleKey]="getSummaryTitle(2)"
          class="summary-grid-item"
          [cssHover]="true"
          (onStepClick)="setEdit($event)">
          <ng-container iconContainer>
            <div class="summary-card__provider-icon">
              <img
                class="summary-card__provider-icon__img"
                [src]="getProviderLogo()"
                [alt]="'provider_logo_alt_text' | translate" />
            </div>
          </ng-container>
          <ng-container detailsContainer>
            <span class="summary-card__text">{{ savingsData?.paymentOption.getName() }}</span>
            <br />
            <span class="text-small-black">
              {{ "recurring_buy_modal_summary_container_two_fees" | translate }}: {{ getProviderFee() }}
            </span>
          </ng-container>
        </summary-grid>
        <summary-grid
          step="3"
          [titleKey]="getSummaryTitle(3)"
          class="summary-grid-item"
          [cssHover]="true"
          (onStepClick)="setEdit($event)">
          <ng-container detailsContainer>
            <div class="justify-center flex-col flex-grow-1">
              <span class="summary-card__text-big">
                {{
                data?.getAmountFiat()
                | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat], symbol: true }
                }}
              </span>
              <hr class="summary-card__custom-hr mb-10 mt-10" />
              <span class="summary-card__text">
                {{ "recurring_buy_modal_plan_details_initial_buy" | translate }}
              </span>
              <span class="text-small-black pl-10 pr-10 text-full-word-break">
                {{ getInitialBuyDate() }}
              </span>
              <span class="summary-card__text mt-10">
                {{ "recurring_buy_modal_summary_container_three_purchases" | translate }}
              </span>
              <span class="text-small-black pl-10 pr-10">{{ savingsData?.getSummaryFrequency() }}</span>
            </div>
          </ng-container>
        </summary-grid>
      </div>
    </div>
    <!-- ITB -->
    @let savingFeeFF = visionSavingBenefitFF$ | async;
    @let vsnSavingFeeBenefit = vsnSavingFeeBenefit$ | async;
    @if (!savingFeeFF) {
      <instant-trade-bonus class="pb-20" [tradeData]="getItbData()" [isSaving]="true" [step]="ITBStep.SUMMARY">
      </instant-trade-bonus>
    }
    <!-- Fee Transparency for crypto -->
    @if ((feeTransparencyEnabledFF$ | async) && isCrypto()) {
      <div class="margin-wrapper">
        @if (savingFeeFF && vsnSavingFeeBenefit?.vsnFeeCollection) {
          <web3-vision-optin-toggle [vm]="vsnSavingFeeBenefit" [showToggle]="false" />
        }
        <collapsible-container-ui (expandHandler)="trackFeeTransparency()">
        <h3 heading class="collapsible-heading">{{ "trans_fee_included" | translate }}</h3>
        <div class="collapsible-content-wrapper">
          <p class="fee-description">{{ "trans_fee_description_saving_plan" | translate }}</p>
          @if (
            savingFeeFF &&
            vsnSavingFeeBenefit?.vsnFeeCollection?.globalOptIn &&
            vsnSavingFeeBenefit?.vsnFeeCollection?.eligibleForVsn
            ) {
            @let vsnAsset = vsnAsset$ | async;
            <p class="fee-benefit">{{
              "fee_transparency_details_future_trades" | translate: [vsnAsset.getSymbol()]
            }}</p>
          }
        </div>
      </collapsible-container-ui>
    </div>
  }
  <!-- Fee Transparency -->
  <!--
  *
  *
  *   BOTTOM
  *
  *
  -->
  <div class="bp-modal-body-upper pt-20 mb-10">
    <!-- dynamic -->
    <terms-and-conditions-updates
      [bundles]="bundles"
      [tradable]="tradable"
    (onTermsBuilding)="setTermsLoadingFinished()"></terms-and-conditions-updates>
  </div>
  <div class="text-center mb-30" [ngClass]="{ 'mb-15': showDerivativeFooter() }">
    <button
      class="btn btn-primary mod-send btn-summary btn-lg mb-0"
				[ngClass]="{
					disabled: isButtonDisabled
				}"
      type="button"
      (click)="acceptOffer()">
      {{ "recurring_buy_modal_summary_confirm_now" | translate }}
    </button>
    @if (showDerivativeFooter()) {
      <div class="trade-modal_powered_by_stocks">
        {{ "stocks_powered_by" | translate }}
      </div>
    }
  </div>
</div>
}
